<template>
  <b-modal id="family-modal" ref="modal" size="lg" :title="title" @show="setData" @hidden="resetModal"
           @ok="handleOk" ok-title="Save">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Relationship Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.family_relation_type" v-model="input_data.family_relationtype_id" :reduce="data=>data.id" label="name" @input="getRelationStatus"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Relationship Status</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.family_relation_status" v-model="input_data.family_relationstat_id" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.family_name)" v-model="input_data.family_name" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nick Name</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.family_nick_name)" v-model="input_data.family_nick_name" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Title</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.salutation" v-model="input_data.family_salutation_id" :reduce="data=>data.id" label="name" ></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Academic Title (Prefix)</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.family_title_prefix)" v-model="input_data.family_title_prefix" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Academic Title (Suffix)</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.family_title_sufix)" v-model="input_data.family_title_sufix" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Gender</label>
                <div class="col-md-8 mb-3">
                  <b-form-radio-group
                      v-model="input_data.family_gender"
                      :options="options.gender"
                      plain
                      name="plain-inline-gender"
                  ></b-form-radio-group>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Place of Birth</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.family_birth_place)" v-model="input_data.family_birth_place" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Birth Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.family_birth_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Religion</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.religion" v-model="input_data.family_religion_id" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Nationality</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.nationality" v-model="input_data.family_country_id" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Blood Type</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.blood_type" v-model="input_data.family_bloodtype_id" :reduce="data=>data.id" label="name"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Address</label>
                <div class="col-md-8 mb-3">
                  <b-form-textarea
                      id="address"
                      placeholder="Address"
                      rows="4"
                      v-model="input_data.family_address_street"
                  ></b-form-textarea>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.country" v-model="input_data.family_address_country_id" :reduce="data=>data.id" label="name" @input="getState"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">State</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.state" v-model="input_data.family_address_state_id" :reduce="data=>data.id" label="name" @input="getCity"></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">City</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.city" v-model="input_data.family_address_city_id" :reduce="data=>data.id" label="name" ></v-select>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Email</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isValidEmail(input_data.family_email)" v-model="input_data.family_email" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="text" class="form-control" :state="isEmpty(input_data.family_phone)" v-model="input_data.family_phone" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Mobile Phone Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.family_mobile)" v-model="input_data.family_mobile" ></b-form-input>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">ID Number</label>
                <div class="col-md-8 mb-3">
                  <b-form-input type="number" class="form-control" :state="isEmpty(input_data.family_identity_number)" v-model="input_data.family_identity_number" ></b-form-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BFormGroup, BFormInput, BButton, BModal, BFormTextarea, BFormRadioGroup, BFormCheckbox} from "bootstrap-vue"

import vSelect  from "vue-select"
import flatPickr from "vue-flatpickr-component";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "FamilyInput",
  components:{
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BFormRadioGroup,
    BFormCheckbox,
    vSelect,
    flatPickr
  },
  data(){
    return {
      title:"Add",
      input_data:{
        family_relationtype_id:"",
        family_relationstat_id:"",
        family_name:"",
        family_nick_name:"",
        family_salutation_id:"",
        family_title_prefix:"",
        family_title_sufix:"",
        family_gender:"",
        family_birth_place:"",
        family_birth_date:"",
        family_religion_id:"",
        family_country_id:"",
        family_bloodtype_id:"",
        family_address_street:"",
        family_address_country_id:"",
        family_address_state_id:"",
        family_address_city_id:"",
        family_email:"",
        family_phone:"",
        family_mobile:"",
        family_identity_number:"",

      },
      options:{
        family_relation_type:[],
        family_relation_status:[],
        salutation:[],
        gender: [{text:"Female", value:"f"}, { text:"Male", value:"m"}],
        religion:[],
        nationality:[],
        country:[],
        state:[],
        city:[],
        blood_type:[],
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  props:{
    data:{
      type:Object
    }
  },
  computed:{
    country(){
      return this.input_data.family_address_country_id
    },
    state(){
      return this.input_data.family_address_state_id
    },
    relation_type(){
      return this.input_data.family_relationtype_id
    }
  },
  watch:{
    country(){
      if(this.input_data.family_address_country_id !== ""){
        if(this.input_data.family_address_country_id !== null ){
          this.getState()
        }
        this.input_data.family_address_state_id = ""
        this.input_data.family_address_city_id = ""
        this.options.city = []
      }

    },
    state(){
      if(this.input_data.family_address_state_id !== "") {
        if (this.input_data.family_address_state_id !== null){
          this.getCity()
        }
      }

    },
    relation_type(){
      if(this.input_data.family_relationtype_id ) this.getRelationStatus()
    }
  },
  methods:{
    isEmpty(val){
      return val !== "" && val !== null && val !== undefined
    },
    isValidEmail(inputText)
    {
      let result
      if ( inputText !== null){
        let  mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if(inputText.match(mailformat))
        {
          result =  true;
        } else {
          result =  false;
        }
      }else{
        result = false
      }
      return result
    },
    setData(){
      this.getRelationshipType()
      this.getSalutation()
      this.getReligion()
      this.getNationality()
      this.getBloodType()
      this.getCountry()
      setTimeout(()=>{
        if(this.data !== null ){
          this.title = "Edit"
          this.input_data = {
            family_relationtype_id:this.data.family_relationtype_id,
            family_relationstat_id:this.data.family_relationstat_id,
            family_name:this.data.family_name,
            family_nick_name:this.data.family_nick_name,
            family_salutation_id:this.data.family_salutation_id,
            family_title_prefix:this.data.family_title_prefix,
            family_title_sufix:this.data.family_title_sufix,
            family_gender:this.data.family_gender,
            family_birth_place:this.data.family_birth_place,
            family_birth_date:this.data.family_birth_date,
            family_religion_id:this.data.family_religion_id,
            family_country_id:this.data.family_country_id,
            family_bloodtype_id:this.data.family_bloodtype_id,
            family_address_street:this.data.family_address_street,
            family_address_country_id:this.data.family_address_country_id,
            family_address_state_id:this.data.family_address_state_id,
            family_address_city_id:this.data.family_address_city_id,
            family_email:this.data.family_email,
            family_phone:this.data.family_phone,
            family_mobile:this.data.family_mobile,
            family_identity_number:this.data.family_identity_number,
          }
        }
      }, 100)
    },
    resetModal(){
      this.title="Add"
      this.$parent.data = null
      this.input_data = {
        family_relationtype_id:"",
        family_relationstat_id:"",
        family_name:"",
        family_nick_name:"",
        family_salutation_id:"",
        family_title_prefix:"",
        family_title_sufix:"",
        family_gender:"",
        family_birth_place:"",
        family_birth_date:"",
        family_religion_id:"",
        family_country_id:"",
        family_bloodtype_id:"",
        family_address_street:"",
        family_address_country_id:"",
        family_address_state_id:"",
        family_address_city_id:"",
        family_phone:"",
        family_mobile:"",
        family_identity_number:"",
        family_email:""
      }
    },
    handleOk(evt){
      evt.preventDefault()
      this.onSubmit()
    },
    onSubmit(){
      let payload = this.input_data
      payload.emp_id = this.$store.getters.empId
      payload.user_id = this.$store.getters.userId
      payload.family_address_state_id = this.input_data.family_address_state_id !== "" ? this.input_data.family_address_state_id : null
      payload.family_address_city_id = this.input_data.family_address_city_id !== "" ? this.input_data.family_address_city_id : null
      if (this.data !== null){
        payload.id = this.data.id
        AxiosCall.Put(payload, urlApi.family.update).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.Post(payload, urlApi.family.add).then(res=>{
          if(res.success){
            this.$parent.successMessage(res.message)
            this.$parent.getData()
            this.$refs.modal.hide()
          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    getRelationshipType(){
      let payload = {}
      AxiosCall.Get(payload, urlApi.reference.relationship_type).then(res=>{
        if(res.success){
          this.options.family_relation_type = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getRelationStatus(){
      if (this.input_data.family_relationtype_id !== null){
        let payload = {
          relationstat_relationtype_id:this.input_data.family_relationtype_id
        }
        AxiosCall.Get(payload, urlApi.reference.relationship_status).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        }).then(res=>{
          if(res.success){
            this.options.family_relation_status = res.atributes
            if (this.data !== null ){
              let found = this.options.family_relation_status.some(el => el.id == this.data.family_relationstat_id);
              this.input_data.family_relationstat_id=(found ? this.data.family_relationstat_id : "" )
            }

          }else {
            this.$parent.errorMessage(res.message)
          }
        })
      }

    },
    getSalutation(){
      AxiosCall.Get({}, urlApi.reference.salutation).then(res=>{
        if (res.success){
          this.options.salutation = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getReligion(){
      AxiosCall.Get({}, urlApi.reference.religion).then(res=>{
        if(res.success){
          this.options.religion = res.atributes
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getNationality(){
      AxiosCall.Get({}, urlApi.country.nationality.list).then(res=>{
        if(res.success){
          this.options.nationality = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getBloodType(){
      AxiosCall.Get({}, urlApi.reference.blood_type).then(res=>{
        if(res.success){
          this.options.blood_type = res.atributes
        }else {
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getCountry(){
      AxiosCall.Get({}, urlApi.country.list).then(res=>{
        if (res.success){
          this.options.country = res.atributes
        }else{
          this.$parent.errorMessage(res.message)
        }
      }).catch(e=>{
        this.$parent.errorMessage(e.response.data.message)
      })
    },
    getState(){
      this.options.state = []
      this.input_data.state = ""

      if(this.input_data.family_address_country_id !== null){
        let payload = {
          country_id:this.input_data.family_address_country_id
        }
        AxiosCall.Get(payload, urlApi.state.combo).then(res=>{
          if(res.success){
            this.options.state = res.atributes
            if (this.data !== null){
              let found = this.options.state.some(el => el.id == this.data.family_address_state_id);
              this.input_data.family_address_state_id=(found ? this.data.family_address_state_id : "" )
            }
          }else {
            this.$parent.errorMessage(res.atributes)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    },
    getCity(){
      this.options.city = []
      this.input_data.city = ""
      if(this.input_data.family_address_state_id !== null){
        let payload = {state_id:this.input_data.family_address_state_id}
        AxiosCall.Get(payload, urlApi.city.combo).then(res=>{
          if(res.success){
            this.options.city = res.atributes
            if(this.data !== null){
              let found = this.options.city.some(el=>el.id==this.data.family_address_city_id)
              this.input_data.family_address_city_id = (found ? this.data.family_address_city_id:"")
            }

          }else{
            this.$parent.errorMessage(res.message)
          }
        }).catch(e=>{
          this.$parent.errorMessage(e.response.data.message)
        })
      }
    }
  },
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>